/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./login-required.component";
import * as i2 from "@angular/router";
import * as i3 from "../../services/user.service";
var styles_LoginRequiredComponent = [];
var RenderType_LoginRequiredComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_LoginRequiredComponent, data: {} });
export { RenderType_LoginRequiredComponent as RenderType_LoginRequiredComponent };
export function View_LoginRequiredComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_LoginRequiredComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_LoginRequiredComponent_0, RenderType_LoginRequiredComponent)), i0.ɵdid(1, 114688, null, 0, i1.LoginRequiredComponent, [i2.Router, i2.ActivatedRoute, i3.UserService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LoginRequiredComponentNgFactory = i0.ɵccf("ng-component", i1.LoginRequiredComponent, View_LoginRequiredComponent_Host_0, {}, {}, []);
export { LoginRequiredComponentNgFactory as LoginRequiredComponentNgFactory };
